(function () {
  'use strict';
  var T = window.theme || {};
  function $(s, r) { return (r || document).querySelector(s); }
  function $$(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }
  var mqDesktop = window.matchMedia('(min-width: 861px)');

  function init(section) {
    if (section.dataset.ready) return;
    section.dataset.ready = '1';

    var variants = [];
    try { variants = JSON.parse($('[data-variants-json]', section).textContent); } catch (e) {}

    var main = $('[data-gal-main]', section);

    /* ---------- Gallery ---------- */
    function showMedia(id) {
      if (!id || !main) return;
      var target = $('.gal-slide[data-media-id="' + id + '"]', main);
      if (!target) return;
      $$('.gal-slide', main).forEach(function (s) { s.classList.toggle('is-active', s === target); });
      $$('.gal-thumb', section).forEach(function (t) { t.classList.toggle('is-active', t.dataset.thumb == id); });
      if (!mqDesktop.matches) { main.scrollTo({ left: target.offsetLeft, behavior: 'smooth' }); }
    }
    // mobile: keep thumbs in sync while swiping
    if (main) {
      var swipeTimer;
      main.addEventListener('scroll', function () {
        if (mqDesktop.matches) return;
        clearTimeout(swipeTimer);
        swipeTimer = setTimeout(function () {
          var slides = $$('.gal-slide', main);
          var w = main.clientWidth || 1;
          var idx = Math.round(main.scrollLeft / w);
          if (slides[idx]) {
            slides.forEach(function (s, i) { s.classList.toggle('is-active', i === idx); });
            $$('.gal-thumb', section).forEach(function (t) { t.classList.toggle('is-active', t.dataset.thumb == slides[idx].dataset.mediaId); });
          }
        }, 80);
      }, { passive: true });
    }

    /* ---------- Zoom (desktop, fine pointer) ---------- */
    if (section.dataset.zoom === 'true' && main) {
      main.addEventListener('mousemove', function (e) {
        if (!mqDesktop.matches) return;
        var slide = e.target.closest('.gal-slide');
        if (!slide || !$('[data-zoom-img]', slide)) return;
        var r = slide.getBoundingClientRect();
        var x = ((e.clientX - r.left) / r.width) * 100;
        var y = ((e.clientY - r.top) / r.height) * 100;
        slide.style.setProperty('--zx', x + '%');
        slide.style.setProperty('--zy', y + '%');
        slide.classList.add('is-zooming');
      });
      main.addEventListener('mouseleave', function () {
        $$('.gal-slide.is-zooming', main).forEach(function (s) { s.classList.remove('is-zooming'); });
      });
    }

    section.addEventListener('click', function (e) {
      var t = e.target.closest('[data-thumb]');
      if (t) showMedia(t.dataset.thumb);

      var step = e.target.closest('[data-qty-step]');
      if (step) {
        var input = $('[data-qty-input]', section);
        input.value = Math.max(1, (parseInt(input.value, 10) || 1) + parseInt(step.dataset.qtyStep, 10));
      }

      var open = e.target.closest('[data-modal-open]');
      if (open) {
        var d = document.getElementById(open.dataset.modalOpen);
        if (d && d.showModal) d.showModal();
      }
      var close = e.target.closest('[data-modal-close]');
      if (close) { var dd = close.closest('dialog'); if (dd && dd.close) dd.close(); }

      var copy = e.target.closest('[data-copy-link]');
      if (copy) {
        var msg = $('[data-copy-msg]', section);
        var done = function () { if (msg) { msg.textContent = (T.strings && T.strings.copied) || ''; setTimeout(function () { msg.textContent = ''; }, 2500); } };
        if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(copy.dataset.copyLink).then(done, done); else done();
      }
    });
    $$('dialog.modal', section).forEach(function (d) {
      d.addEventListener('click', function (e) { if (e.target === d) d.close(); });
    });

    /* ---------- Variants ---------- */
    var picker = $('[data-variant-picker]', section);
    var idInput = $('[data-variant-id]', section);
    var addBtn = $('[data-main-atc]', section);
    var addLabel = $('[data-add-label]', section);
    var priceEl = $('[data-price]', section);
    var compareEl = $('[data-compare-price]', section);
    var savingsEl = $('[data-savings]', section);
    var stockEl = $('[data-stock]', section);
    var skuEl = $('[data-sku]', section), skuWrap = $('[data-sku-wrap]', section);
    var barEl = $('[data-barcode]', section), barWrap = $('[data-barcode-wrap]', section);
    var bis = $('[data-bis]', section);
    var dyn = $('[data-dynamic-checkout]', section);
    var sticky = $('[data-sticky-atc]', section);
    var stickyPrice = $('[data-sticky-price]', section);
    var stickyBtn = $('[data-sticky-atc-btn]', section);
    var stickyLabel = $('[data-sticky-label]', section);
    var tAdd = section.dataset.tAdd, tSold = section.dataset.tSold, tUnavail = section.dataset.tUnavailable;
    var tIn = section.dataset.tInStock, tLow = section.dataset.tLowStock, tOut = section.dataset.tOutOfStock;
    var lowThreshold = parseInt(section.dataset.lowThreshold, 10) || 5;

    function selectedOptions() {
      return $$('[data-option-index]', picker).map(function (fs) {
        var sel = $('[data-option-select]', fs);
        if (sel) return sel.value;
        var c = $('input:checked', fs);
        return c ? c.value : null;
      });
    }
    function setStock(v) {
      if (!stockEl) return;
      stockEl.className = 'pstock';
      if (!v.available) { stockEl.textContent = tOut; stockEl.classList.add('is-out'); return; }
      if (v.managed && v.inventory > 0 && v.inventory <= lowThreshold) {
        stockEl.textContent = tLow.replace('[count]', v.inventory); stockEl.classList.add('is-low'); return;
      }
      stockEl.textContent = tIn; stockEl.classList.add('is-in');
    }
    function setButtons(label, disabled) {
      if (addBtn) { addBtn.disabled = disabled; addBtn.setAttribute('aria-disabled', disabled ? 'true' : 'false'); }
      if (addLabel) addLabel.textContent = label;
      if (stickyBtn) stickyBtn.disabled = disabled;
      if (stickyLabel) stickyLabel.textContent = label;
    }
    function apply(v) {
      idInput.value = v.id;
      if (priceEl) { priceEl.textContent = v.price; priceEl.classList.toggle('sale', !!v.compare); }
      if (compareEl) { compareEl.textContent = v.compare; compareEl.hidden = !v.compare; }
      if (savingsEl) { savingsEl.textContent = savingsEl.textContent.replace(/\d+/, v.saving); savingsEl.hidden = !v.saving; }
      if (stickyPrice) stickyPrice.textContent = v.price;
      if (skuEl) { skuEl.textContent = v.sku || ''; if (skuWrap) skuWrap.hidden = !v.sku; }
      if (barEl) { barEl.textContent = v.barcode || ''; if (barWrap) barWrap.hidden = !v.barcode; }
      setStock(v);
      setButtons(v.available ? tAdd : tSold, !v.available);
      if (bis) bis.hidden = v.available;
      if (dyn) dyn.hidden = !v.available;
      $$('[data-pickup-variant]', section).forEach(function (p) { p.hidden = p.dataset.pickupVariant != v.id; });
      if (v.media) showMedia(v.media);
      try {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', url.toString());
      } catch (e) {}
    }
    function update() {
      var sel = selectedOptions();
      var match = variants.filter(function (v) { return v.options.every(function (o, i) { return o === sel[i]; }); })[0];
      if (!match) {
        setButtons(tUnavail, true);
        if (stockEl) { stockEl.textContent = tOut; stockEl.className = 'pstock is-out'; }
        return;
      }
      apply(match);
    }
    if (picker) picker.addEventListener('change', update);
    // set initial stock text
    var initial = variants.filter(function (v) { return String(v.id) === String(idInput && idInput.value); })[0];
    if (initial) setStock(initial);

    /* ---------- Sticky add to cart (mobile) ---------- */
    if (sticky && addBtn && 'IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          var small = !mqDesktop.matches;
          sticky.hidden = !(small && !en.isIntersecting && en.boundingClientRect.top < 0);
        });
      });
      io.observe(addBtn);
    }
    if (stickyBtn) {
      stickyBtn.addEventListener('click', function () {
        var form = $('[data-product-form]', section);
        if (form && form.requestSubmit) form.requestSubmit(); else if (form) form.submit();
      });
    }

    /* ---------- Recently viewed: remember this product ---------- */
    try {
      var cur = JSON.parse($('[data-recent-json]', section).textContent);
      var list = JSON.parse(localStorage.getItem('amarelis_recent') || '[]');
      list = list.filter(function (p) { return p.handle !== cur.handle; });
      list.unshift(cur);
      localStorage.setItem('amarelis_recent', JSON.stringify(list.slice(0, 12)));
    } catch (e) {}
  }

  function initAll() { $$('[data-product-section]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll); else initAll();
  document.addEventListener('shopify:section:load', initAll);
})();
